export default  {	
	data () {
		return { 
			filter: {
				inicial: this.fecha().inicioLabores.servicios,
				final: this.fecha().fecha.minHoy,
				id_datos_asesor: null
			}
		}
	},
	async created () { 
		// frontend this.searchGetIdb({tabla:'info_ingresos'})
	},
}
